// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__YJDgV","fieldContainer":"Counter_fieldContainer__zkkcx","button":"Counter_button__MyRzf","input":"Counter_input__71V2b","error":"Counter_error__xv14-"};